import React from "react";

export default function QuickActionButton({
  icon,
  label,
  description,
  onClick,
}) {
  const Icon = icon;

  return (
    <button
      type="button"
      onClick={onClick}
      className="p2-quick-action"
    >
      <div className="p2-quick-action-icon">
        {Icon && <Icon className="p2-quick-action-icon-svg" />}
      </div>
      <span className="p2-quick-action-label">
        {label}
      </span>
      {description && (
        <span className="p2-quick-action-desc">
          {description}
        </span>
      )}
    </button>
  );
}
